var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74392 1.89296C9.85639 1.70235 10.1436 1.70235 10.2561 1.89296L12.4972 5.6913C12.7524 6.12384 13.178 6.42747 13.6674 6.5321L18.0194 7.4624C18.2475 7.51115 18.3153 7.76732 18.1776 7.91939L15.2108 11.1972C14.8737 11.5695 14.7092 12.0667 14.7606 12.5674L15.2091 16.9407C15.2293 17.1378 15.0176 17.3201 14.7949 17.2232L10.7201 15.4507C10.2611 15.251 9.73888 15.251 9.27988 15.4507L5.20513 17.2232C4.98239 17.3201 4.77068 17.1378 4.79089 16.9407L5.23944 12.5674C5.2908 12.0667 5.12625 11.5695 4.78925 11.1972L1.82236 7.91939C1.68472 7.76732 1.75255 7.51115 1.98058 7.4624L6.33255 6.5321C6.822 6.42747 7.2476 6.12384 7.50281 5.6913L9.74392 1.89296Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.abdc6d9b6a60c4ece9766e67f99b98c3.svg";
export { ForwardRef as ReactComponent };